export { View as Tab2023 } from './view'
